import { css } from 'linaria';
import { StylesMap } from 'types/utils';
import { CashbackPlateSize } from './cashback-plate-types';

export const cashbackPlate = css`
  display: flex;
  align-items: center;
  column-gap: 4px;
  position: relative;
  width: fit-content;
  z-index: 10;
`;

export const cashbackPlateSizeMap: StylesMap<CashbackPlateSize> = {
  l: css`
    padding: 0px 13px;
    height: 24px;
  `,
  m: css`
    padding: 0px 10px;
    height: 20px;
  `,
  s: css`
    padding: 0px 5px;
    height: 16px;
  `,
}

export const cashbackPlateImageSizeMap: StylesMap<CashbackPlateSize> = {
  l: css`
    height: 24px;
  `,
  m: css`
    height: 20px;
  `,
  s: css`
    height: 16px;
  `,
}

export const cashbackPlateImage = css`
  position: absolute;
  z-index: -1;
  width: 100%;
  left: 0;
`;

export const cashbackIcon = css`
  width: 12px;
  height: 13px;
`;

export const cashbackText = css`
  font-weight: 700;

  @media (--only-mobile) {
    font-size: 9px;
    line-height: 14px;
  }
`;

export const cashbackTextSmall = css`
  && {
    font-size: 9px;
    line-height: 14px;
  }
`;

